module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_02@3x-8b47605676f90a020b7ba6de22ebe3f2.webp";